/**
 * Display name for a doc type or sub type id, from GET /bedrock/doc-types
 * definitions. Null for missing/'Mixed' ids; the id itself when unknown.
 * (The client report's section grouping lives in the backend section map
 * and utils/clientReport.js.)
 */
export const resolveTypeName = (docTypes, id) => {
  if (!id || id === 'Mixed') return null;
  const docType = (docTypes || []).find((dt) => dt.id === id);
  if (docType) return docType.name;
  for (const dt of docTypes || []) {
    const sub = (dt.sub_types || []).find((st) => st && st.id === id);
    if (sub) return sub.name;
  }
  return id;
};
